import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip"
import _ from "lodash"

import "../index.css"

import { Button, DropDownField, TextAreaField, TextInputField } from "../../../helpers";
import MaterialModal from "./AddMaterialModal";
import Product from "./Product";
import BillingAddressCards from "../../../common/BillingAddressCards";
import ShippingAddressCards from "../../../common/ShippingAddressCards";
import Loading from "../../../common/Loading";
import SellerSearch from "../../../common/SellerSearch";

import { getExpenseCategories } from "../../../services/api/expenseCategories";
import { getCompanyBillAddrs } from "../../../services/api/companyBillAddr";
import { fetchStates, fetchTDSSections } from "../../../services/redux/reducers/commonThunk";
import { getCompanyGSTINs } from "../../../services/api/companyGSTINs";
import { insertSellerPO } from "../../../services/api/sellerPO";
import { getUOMs} from "../../../services/api/pettyCash";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getCompanyBankAccounts } from "../../../services/api/companyBankAccount";

import { AddExpenseProductsSchema, AddExpenseSchema, initialTransactionDetails } from "../../../validation/addExpense";
import { calculateAddExpense, validateInputs} from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { checkForSuspensePayments } from "../../../services/api/vendorPayment";


let tdsOptions = [
	{tdsSectionId: 1, tdsSection: 'No TDS', displayTDSSection: 'No TDS | 0%', tdsValue: 0},
	{tdsSectionId: 2, tdsSection: '194J', displayTDSSection: '194J | 10%', tdsValue: 10},
	{tdsSectionId: 3, tdsSection: '194C', displayTDSSection: '194C | 1%', tdsValue: 1},
	{tdsSectionId: 4, tdsSection: '194Q', displayTDSSection: '194Q | 0.1%', tdsValue: 0.1},
	{tdsSectionId: 5, tdsSection: 'Other', displayTDSSection: 'Other', tdsValue: null},
]

const AddExpense = (props) => {
	const { setVisibleAddExpense, HSNMasterData, companyCreditPeriods } = props

	const [visibleAssignseller, setVisibleAssignSeller] = useState(false);
	const [productsList, setProductsList] = useState([])
	const [expenseCategories, setExpenseCategories] = useState([])
	const [UOMData, setUOMData] = useState([])
	const [sellerPO, setSellerPO] = useState(initialTransactionDetails)
	const [sellerData , setSellerData] = useState({})
	const [statesData, setStatesData] = useState([])
	const [productErrors, setProductErrors] = useState({})
	const [formErrors , setFormErrors] = useState({})

	const [isLoading, setIsLoading] = useState(false)
	const [isMaterialModalVisible, setIsMaterialModalVisible] = useState(false)
	const [procmartCompanyBillAddrs, setProcmartCompanyBillAddrs] = useState([])
	const [isBillAddrsLoading, setIsBillAddrsLoading] = useState(false)
	const [sellerBillAddrs, setSellerBillAddrs] = useState([])
	const [selectedBillAddrId, setSelectedBillAddrId] = useState(null)
	const [pmShipAddrs, setPMShipAddrs] = useState([])
	const [selectedShipAddrId, setSelectedShipAddrId] = useState(null)
	const [pmBranches, setPMBranches] = useState([])
	const [pmBranchId, setPMBranchId] = useState(null)
	const [pmBillAddrId, setPMBillAddrId] = useState(null)
	const [remarks, setRemarks] = useState('')
	const [TDSDisplayData, setTDSDisplayData] = useState({
        tdsSectionName: '',
        tdsValue: null
    })
	const [sellerBankAccounts, setSellerBankAccounts] = useState([])
	const [prefBankAccountId, setPrefBankAccountId] = useState(null)
    
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const usersData = useSelector(state => state.userDetails)

	const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
	const statesDetails = useSelector((state) => state.common.states)
	const rolesList = useSelector((state) => state.userDetails.rolesList)
    const activeRoleId = useSelector((state) => state.userDetails.activeRoleId)
	const tdsSections = useSelector(state => state.common.tdsSections)

	const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
	
	useEffect(() => {
		fetchPettyCashCategoryData()
        dispatch(fetchStates())
		dispatch(fetchTDSSections())

		prefillPMBranches()
	},[pmCompanyDetails])

	useEffect(() => {
		if(statesDetails.length > 0){
			getProcmartStates()
		}
	}, [statesDetails, pmCompanyDetails])

	useEffect(() => {
		let updatedProductsList = productsList.map(eachProduct => {
			if (pmCompanyConfig.defaultHSNCode){
				eachProduct.HSNCode = pmCompanyConfig.defaultHSNCode
			}
			return eachProduct
		})

		let tdsSection
		let tdsValue = null
		if (pmCompanyConfig.isTDSAutomated) {
			const isServiceHSNsProductsExists = updatedProductsList.some(eachProduct => {
				if (eachProduct.HSNCode && eachProduct.HSNCode.toString().slice(0, 2) === '99' && eachProduct.HSNCode.toString().length === 6) {
					return true
				}
				return false
			})

			if (isServiceHSNsProductsExists) {
				if (sellerData.tdsSectionId === 1 || !sellerData.tdsSectionId) {
					return
				} else {
					tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === sellerData?.tdsSectionId)
				}
			} else if (sellerData.tdsSection194q) {
				tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 1)
			} else {
				tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
			}

			if (sellerData.panCode && sellerData.panCode[3] === "P") {
				tdsValue = tdsSection.individualTDSRate
			} else {
				tdsValue = tdsSection?.othersTDSRate
			}
		}

		setTDSDisplayData(prevState => ({
            ...prevState,
            tdsSectionName: tdsSection?.tdsSectionName,
            tdsValue: tdsValue
        }))

	}, [sellerPO])
	
	const prefillPMBranches = () => {
        const activeRole = rolesList.find(eachRole => eachRole.userRoleId === activeRoleId)

        let relatedBranches = []
        if(activeRole.branchId === 0){
            relatedBranches = pmCompanyDetails.companyBranches
        }
        else{
            relatedBranches = pmCompanyDetails.companyBranches.filter(eachBranch => eachBranch.branchId === activeRole.branchId)
        }
        setPMBranches(relatedBranches)
    }

	const getProcmartStates = async () => {
        const allPrimaryBillAddrId =  _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const response = await getCompanyBillAddrs({ companyIds: [pmCompanyDetails.companyId], statusIds: [1], paginator: false })
		// console.log("response in use effect", response)

        if(response.failure){
            dispatch(raiseToast({severity:'error', summary: 'Billing Address', detail: response.data.error , life: 3000}))
        }
        setProcmartCompanyBillAddrs(response.data.data)

		// console.log("userRole", usersData, pmCompanyDetails.companyBranches)
		
		let activeRoleId = usersData?.activeRoleId
		const activeRole = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)
		let PMState = null
		let pmBranchId = null
		if (activeRole?.branchId === 0){
			PMState = pmCompanyConfig.defaultStateId
			pmBranchId = pmCompanyConfig.defaultPMBranchId
		}else{
			let relatedBranch = pmCompanyDetails.companyBranches?.find(eachCompanyBranch => eachCompanyBranch?.branchId === activeRole?.branchId)
			const relatedState = response?.data?.data?.find(eachBillAddr => eachBillAddr?.billAddrId === relatedBranch?.primaryBillAddrId)
			PMState = relatedState?.stateId
			pmBranchId = activeRole?.branchId
		}

		setSellerPO(prevState => ({...prevState, PMState: PMState}))
		setPMBranchId(pmBranchId)

		const relatedShipAddrs = pmCompanyDetails.companyBranchShipAddrs.filter(eachShipAddr => eachShipAddr.branchId === pmBranchId)

		setPMShipAddrs(relatedShipAddrs)

		// setSellerPO(prevState => ({...prevState, PMState : response?.data?.data?.stateId}))

        const allStateIds = _.map(response.data.data, 'stateId')
        const filteredStates = _.filter(statesDetails, (state) => allStateIds.includes(state.stateId))
		// setPMBranches(response.data.data)
        setStatesData(filteredStates)
    }

	const getShipAddrs = async () => {
		const allPrimaryShipAddrIds = pmCompanyDetails.companyBranches.map(eachBranch => eachBranch.primaryShipAddrId)
		console.log("allPrimaryShipAddrIds", allPrimaryShipAddrIds)

		const relatedShipAddrs = pmCompanyDetails.companyBranchShipAddrs.filter(eachShipAddr => allPrimaryShipAddrIds.includes(eachShipAddr.shipAddrId))

		console.log("relatedShipAddrs", relatedShipAddrs)
		setPMShipAddrs(relatedShipAddrs)	
	}

	
	let gstRates = pmCompanyConfig.GSTRates
    let gstValues = []
    gstRates.map(eachGSTRate => gstValues.push({label: eachGSTRate.toString(), value: eachGSTRate}))

	const fetchPettyCashCategoryData = async () => {
		const response = await getExpenseCategories()
		if (response?.failure){
			dispatch(raiseToast({severity:'error', summary: 'Expense Categories', detail: response.data.error , life: 3000}))
		}
		const UOMDataRes = await getUOMs()
		if (UOMDataRes?.failure){
			dispatch(raiseToast({severity:'error', summary: 'UOM Data', detail: UOMDataRes.data.error , life: 3000}))
		}

		let sortedExpenseCategories = _.sortBy(response.data, "expenseCategoryName")
		setUOMData(UOMDataRes)
		setExpenseCategories(sortedExpenseCategories)

		if(sortedExpenseCategories.length === 1){
			setSellerPO(prevState => ({...prevState, expenseCategoryId: sortedExpenseCategories[0].expenseCategoryId}))
		}
	}
	
	const handleOnAddExpense = async () => {

		let updatedProductsList = productsList.map(eachProduct => {
			if (pmCompanyConfig.defaultHSNCode){
				eachProduct.HSNCode = pmCompanyConfig.defaultHSNCode
			}
			eachProduct.listPrice = eachProduct.unitPrice
			return eachProduct
		})

		if(!pmBranchId){
			return dispatch(raiseToast({severity:'error', detail: "Please select PM Branch", life: 3000}))
		}
		if (!sellerData?.userId){
			return dispatch(raiseToast({severity:'error', detail: "Please Assign the Seller", life: 3000}))
		}

		if (productsList?.length === 0){
			return dispatch(raiseToast({severity:'error', detail: "Please Add the products", life: 3000}))
		}
        if(sellerBankAccounts.length && !prefBankAccountId){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select bank account` }))
        }

		if (parseFloat(paymentTermsTotal) !== 100) {
            return dispatch(raiseToast({ severity: 'error', detail: "Net total of payment terms should be 100. Please update it in the company module.", life: 3000 }))
        }

		if(!selectedBillAddrId){
			return dispatch(raiseToast({severity:'error', detail: "Please select seller billing address", life: 3000}))
		}

		if(!pmBillAddrId){
			return dispatch(raiseToast({severity:'error', detail: "Please select PM billing address", life: 3000}))
		}

		if(!selectedShipAddrId){
			return dispatch(raiseToast({severity:'error', detail: "Please select shipping address", life: 3000}))
		}

		const isHSNCodeInvalid = updatedProductsList.some(eachProduct => {
			if(eachProduct?.HSNCode){
				const relatedHSNCode = HSNMasterData.find(eachHSN => eachHSN.HSNCode === parseInt(eachProduct.HSNCode))

				if(!relatedHSNCode){
					dispatch(raiseToast({ severity: 'error', detail: `Please enter Valid HSN Code for material ID ${eachProduct?.materialId}`, life: 3000 }))
					return true
				}
			}
			return false
		})

		if(isHSNCodeInvalid) {
			return
		}

		const isGSTApplied = productsList.some(eachProduct => eachProduct.GSTRate)
		if(isGSTApplied){
			const relatedBillAddr = sellerBillAddrs.find(eachBillAddr => eachBillAddr.billAddrId === selectedBillAddrId)
			if(relatedBillAddr && ["URD", "URP"].includes(relatedBillAddr.gstinCode)){
				return dispatch(raiseToast({severity: 'error', detail: "GST cannot be applied to a URD seller"}))
			}
		}

		// console.log("productsList", productsList)

		const validation_res = await validateInputs(AddExpenseSchema, sellerPO)
		const validation_res_2 = await validateInputs(AddExpenseProductsSchema, updatedProductsList)
		if (validation_res  || validation_res_2){
			console.log(validation_res, validation_res_2)
			if (validation_res.error){
				setFormErrors(validation_res.error)
			} else
			if (validation_res_2.error){
				setProductErrors(validation_res_2.error)
				setFormErrors({})
			} else {
				setProductErrors({})
				setFormErrors({})
				const relatedUserCompanyDetails = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === usersData?.activeRoleId) 
				// const relatedCompanyShipAddrs = usersData?.PMCompanyDetails?.companyBranchShipAddrs?.find(eachShipAddr => eachShipAddr?.branchId === relatedUserCompanyDetails?.branchId)
				let relatedShipAddr = {}
				if (relatedUserCompanyDetails?.branchId === 0){
					relatedShipAddr.shipAddrId = 1
				}else{
					relatedShipAddr = usersData?.PMCompanyDetails?.companyBranches?.find(eachCompanyBranch => eachCompanyBranch?.branchId === relatedUserCompanyDetails?.branchId)
				}
				
				const GSTType = sellerData?.stateId === sellerPO?.PMState ? "CS" : "I"
				const isURD = sellerData?.gstinCode ? false : true

				updatedProductsList = updatedProductsList?.map(eachProduct => ({...eachProduct, listPrice: eachProduct?.unitPrice, shipAddrId: relatedShipAddr?.shipAddrId}))
				// if (!sellerData?.primaryBillAddrId){
				// 	dispatch(raiseToast({severity:'error', summary: 'Seller Bill Address', detail: "Bill Address Id is Not Found.", life: 3000}))
				// }else{

				let tdsSection 
				let tdsValue = null
				if (pmCompanyConfig.isTDSAutomated){
					const isServiceHSNsProductsExists = updatedProductsList.some(eachProduct => {
						if(eachProduct.HSNCode.toString().slice(0, 2) === '99' && eachProduct.HSNCode.toString().length === 6){
							return true
						}
						return false
					})
			
					if (isServiceHSNsProductsExists){
						if (sellerData.tdsSectionId === 1 || !sellerData.tdsSectionId) {
							return dispatch(raiseToast({ severity: 'error', detail: "Services are not enabled for the vendor - please enable by selecting correct service Type in Companies Page.", life: 3000 }))
						} else {
							tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === sellerData?.tdsSectionId)
						}
					} else if (sellerData.tdsSection194q){
						tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 1)
					} else {
						tdsSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === 8)
					}

					if (sellerData.panCode && sellerData.panCode[3] === "P"){
						tdsValue = tdsSection.individualTDSRate
					}else{
						tdsValue = tdsSection.othersTDSRate
					}
			
					updatedProductsList = updatedProductsList.map(eachProduct => {
						eachProduct.tdsSectionId = tdsSection.tdsSectionId
						eachProduct.tdsSection = tdsSection.tdsSectionName
						eachProduct.tdsValue = tdsValue
						return eachProduct
					})
				}else{
					tdsValue = null
					let isTDSEntered = updatedProductsList.every(eachProduct => {
						return eachProduct.tdsValue
					})
		
					if (!isTDSEntered){
						return dispatch(raiseToast({ severity: 'error', detail: "Please enter tds value for every item.", life: 3000 }))
					}
				}

				let data = {
					newSellerPO : {
						...sellerPO,
						expenseCategoryId : sellerPO.expenseCategoryId,
						logisticsBeforeTax: sellerPO?.logisticsBeforeTax,
						logisticsGSTRate : sellerPO?.logisticsGSTRate ? sellerPO?.logisticsGSTRate : 0,
						logisticsTDS : sellerPO?.logisticsTDSValue,
						logisticsHSNCode : pmCompanyConfig.defaultHSNCode ? pmCompanyConfig.defaultHSNCode : parseInt(sellerPO?.logisticsHSNCode),
						companyId : sellerData.companyId,
						branchId : sellerData.branchId,
						shipAddrId : selectedShipAddrId,
						billAddrId : selectedBillAddrId,
						pmCompanyId : relatedUserCompanyDetails.pmCompanyId,
						pmBranchId : pmBranchId,  
						pmBillAddrId : pmBillAddrId,
						userId : sellerData.userId,
						GSTType : GSTType,
						isURD: isURD,
						paymentTerms: sellerData.companyPaymentTerms,
						remarks: remarks,
						tdsSectionId: tdsSection?.tdsSectionId, 
						tdsValue: tdsValue,
						prefBankAccountId: prefBankAccountId
					},
					bulkSellerPOItems : updatedProductsList
				}
				
				const calculatedValues = calculateAddExpense(data?.newSellerPO, data?.bulkSellerPOItems)
				data.newSellerPO = calculatedValues.sellerPO
				data.bulkSellerPOItems = calculatedValues.sellerPOItems

				if (window.confirm("Are you sure you want to continue...?")){
					setIsLoading(true)

					const suspenseCheckResponse = await checkForSuspensePayments(data.newSellerPO.companyId)
					console.log("handleCheckForSuspensePayments response", suspenseCheckResponse)
					if(suspenseCheckResponse?.failure){
						setIsLoading(false)
						dispatch(raiseToast({severity:'error', summary: 'Suspense Payments', detail: suspenseCheckResponse.data.error, life: 3000}))
						return false
					}
					if(suspenseCheckResponse?.data?.isSuspensePayment){
						if(!window.confirm(`Suspense payments found for the company. Are you sure you want to continue?`)){
							setIsLoading(false)
							return false
						}
					}
					
					const response = await insertSellerPO(data)
					if (response?.failure){
						setIsLoading(false)
						dispatch(raiseToast({severity:'error', summary: 'Seller PO Expenses are not Added', detail:response.data.error, life: 3000}))
					}else {
						dispatch(raiseToast({severity:'success', detail: 'Seller PO Expenses are Added Successfully', life: 3000}))
						setSellerPO({})
						setSellerData({})
						setSellerBankAccounts([])
						setPrefBankAccountId(null)
						setProductsList([])
						setVisibleAddExpense(false)
						setIsLoading(false)

						navigate(`/sellerpo/${response?.data?.sellerPO?.sellerPOId}`)
					}
				}
			}
		}
		
	}

	const handleChange = async (e) => {
		if (e.target.name === 'logisticsTDSValue'){
			if (!pmCompanyConfig.isTDSAutomated){
				setSellerPO(prevState => ({...prevState, "logisticsTDSSection": 'Other'}))
			}
		}
        setSellerPO(prevState => ({...prevState, [e.target.name] : e.target.value}))
    }

	const handleProcmartState = (e) => {
		const relatedBillAddr = procmartCompanyBillAddrs.find(eachBillAddr => eachBillAddr.stateId === e.target.value)

		if(e.target.name === "PMState"){
			setPMBillAddrId(null)
		}

		setSellerPO(prevState => ({...prevState, [e.target.name] : e.target.value, pmBillAddrId: relatedBillAddr?.billAddrId}))
	}

	const handleSellerBillAddrr = (id) => {
		setSelectedBillAddrId(id)
    }

	const handleShippingAddress = (id) => {
		setSelectedShipAddrId(id)
	}
	
	const handleOnAddSeller = async (id, data) => {
		setIsBillAddrsLoading(true)

		const relatedSeller = data.find(eachSeller => {
			if (eachSeller.id === id){
				setVisibleAssignSeller(false)

				let updatedProductsList = [...productsList]
				if(eachSeller.tdsSection194q && pmCompanyConfig.canApplyTds194Q){
					updatedProductsList = productsList.map(eachProduct => {
						return { ...eachProduct, tdsSectionId: 4, tdsSection: "194Q", tdsValue: 0.1}
					})
				}
				setProductsList(updatedProductsList)
				return true
			}
			
			return false
		})
		
		const comapnyGSTINsRes = await getCompanyGSTINs({companyIds: [relatedSeller.companyId], paginator: false, statusIds: [1]})
		if(comapnyGSTINsRes.failure){
			return dispatch(raiseToast({severity:'error', summary: 'comapnyGSTINsRes', detail: comapnyGSTINsRes.data.error, life: 3000}))
		}

		const gstinCodes = comapnyGSTINsRes.data.data.map(eachGSTINCode => eachGSTINCode.gstinCode)
		let companyBillAddrsRes = []
		if (gstinCodes?.length > 0){
			companyBillAddrsRes = await getCompanyBillAddrs({gstinCodes: gstinCodes, paginator: false, statusIds: [1], companyIds: [relatedSeller?.companyId]})
			// console.log("companyBillAddrRes", companyBillAddrsRes)
			if(companyBillAddrsRes?.failure){
				return dispatch(raiseToast({severity:'error', summary: 'companyBillAddrsRes', detail: companyBillAddrsRes.data.error, life: 3000}))
			}
			companyBillAddrsRes = companyBillAddrsRes.data.data
		}

		const sellerBankAccountResponse = await getCompanyBankAccounts({ companyIds: [relatedSeller.companyId], paginator: false })
		if (sellerBankAccountResponse.failure) {
			dispatch(raiseToast({ severity: 'error', summary: 'Seller Bank Accounts', detail: sellerBankAccountResponse.data.error, life: 3000 }))
		}
		let sellerBankAccounts = sellerBankAccountResponse.data.data
		const relatedSellerBankAccounts = sellerBankAccounts.filter(eachBankAccount => eachBankAccount.companyId === relatedSeller.companyId && eachBankAccount.branchId.includes(relatedSeller.branchId))
		if (relatedSellerBankAccounts.length) {
			setSellerBankAccounts([...sellerBankAccounts])
			if (relatedSellerBankAccounts.length === 1) {
				setPrefBankAccountId(relatedSellerBankAccounts[0].bankAccId)
			}else{
				setPrefBankAccountId(null)
			}
		}else {
			setSellerBankAccounts([])
		}

		setSellerData(relatedSeller)
		setSellerBillAddrs(companyBillAddrsRes)
		setSelectedBillAddrId(null)
		setSelectedShipAddrId(null)
		setIsBillAddrsLoading(false) 
	}

	const handleOnAddProduct = () => {
		setIsMaterialModalVisible(true)
	}

	const handleOnDeleteProduct = (id) => {
		const filteredProductsList = productsList.filter(eachProduct => eachProduct.id !== id)
		setProductsList([...filteredProductsList])
	}

	const handleProductChange = (id, name, value) => {
		const updatedProductsList = productsList.map(eachProduct => {
			if (eachProduct.id === id) {
				return { ...eachProduct, [name]: value, tdsSectionId: name === "HSNCode" ? null : eachProduct.tdsSectionId }
			}
			return eachProduct
		})
		const calculatedValues = calculateAddExpense(sellerPO, updatedProductsList)

		setSellerPO(calculatedValues?.sellerPO)
		setProductsList(calculatedValues?.sellerPOItems)
	}

	const handleOnResetProductsList = () => {
		setProductsList([])
	}

	const handleLogisticsTDSSelection = (e) => {
        const relatedTDSOption = updatedTDSOptions.find(eachTDS => eachTDS.tdsSectionId === e.target.value)

        const updatedTransactionDetails =  {
			...sellerPO, 
			logisticsTDSSection: relatedTDSOption.tdsSection, 
			tdsSectionId: e.target.value, 
			logisticsTDSValue: relatedTDSOption.tdsValue
		}
        
        setSellerPO(updatedTransactionDetails)
	}

	const handlePMBranchId = (e) => {
		setPMBranchId(e.target.value)

		const relatedShipAddrs = pmCompanyDetails.companyBranchShipAddrs.filter(eachShipAddr => eachShipAddr.branchId === e.target.value)

		setPMShipAddrs(relatedShipAddrs)
	}

	const handlePMBillAddrr = (id) => {
		setPMBillAddrId(id)
	}

	const handleRemarks = (e) => {
		setRemarks(e.target.value)
	}

	const handleOnChangeBankAccount = (e) => {
		setPrefBankAccountId(e.target.value)
	}

	let updatedTDSOptions = []
    if(sellerData.tdsSection194q){
        updatedTDSOptions = [tdsOptions[3], tdsOptions[4]]
    }else{
        if(sellerData?.panCode?.[3] === "P"){
            if(sellerPO?.logisticsHSNCode?.slice(0,2) === "99"){
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            }else{
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }else{
            tdsOptions = tdsOptions.map(eachOpt => {
                if(eachOpt.tdsSection === "194C"){
                    return { ...eachOpt, displayTDSSection: '194C | 2%', tdsValue: 2 }
                }
                return eachOpt
            })

            if(sellerPO?.logisticsHSNCode?.slice(0,2) === "99"){
                updatedTDSOptions = [tdsOptions[1], tdsOptions[2], tdsOptions[4]]
            }else{
                updatedTDSOptions = [tdsOptions[0], tdsOptions[4]]
            }
        }
    }

	const relatedPMBillAddrs = procmartCompanyBillAddrs.filter(eachBillAddr => eachBillAddr.stateId === sellerPO?.PMState)

	let paymentTermsTotal = 0
	if(sellerData?.companyPaymentTerms){
		Object.keys(sellerData?.companyPaymentTerms).forEach(eachKey => {
			if (eachKey !== "creditPeriodId") paymentTermsTotal += parseFloat(sellerData?.companyPaymentTerms[eachKey])
		})
	}

	const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed
	
	return (
		<>
			<div className="add-expense">
				<div className="p-card">
					<div className="grid">
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
							<DropDownField name="pmBranchId" labelText="PM Branch" optionLabel="branchName" optionValue="branchId" options={pmBranches} value={pmBranchId} onChange={(e) => handlePMBranchId(e)} />
						</div>
						<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
							<DropDownField name="PMState" labelText="PM State" optionLabel="stateName" optionValue="stateId" options={statesData} errorMessage={formErrors.PMState} value={sellerPO?.PMState} onChange={(e) => handleProcmartState(e)} />
						</div>
						<div className="flex flex-column col-12 mb-2 lg:col-6 lg:mb-0">
                            <DropDownField name="expenseCategoryId" labelText="Nature Of Expenses" options={expenseCategories} optionLabel="expenseCategoryName" optionValue="expenseCategoryId"  errorMessage={formErrors.expenseCategoryId} value={sellerPO?.expenseCategoryId} onChange={(e) => handleChange(e)}/>
                        </div>
					</div>
				</div>
				<div className="p-card">
					<Button className="h-2rem  p-2" label="ASSIGN SELLER" onClick={() => setVisibleAssignSeller(true)} />
					{
						sellerData?.name && 
						<div> <p> {sellerData?.name} | {sellerData?.emailId} | {sellerData?.companyName} | {sellerData?.branchName} </p></div>
					}
					</div>
				{
					productsList?.map((eachProduct, index) => {
						return (
							<div key={`product-${eachProduct.productId}`}>
								<Product 
									index={index} 
									error={productErrors} 
									sellerPO={sellerPO} 
									sellerData={sellerData} 
									UOMData={UOMData} 
									handleProductChange={handleProductChange} 
									product={eachProduct} 
									productId={eachProduct.id} 
									setProductsList={setProductsList} 
									handleOnDeleteProduct={handleOnDeleteProduct} 
									productsList={productsList} 
								/>
							</div>
						)
					})
				}
				<Loading visible={isLoading} />
				<div className="flex flex-row justify-content-between add-reset-buttons mb-3">
					<Button className="h-2rem p-2 font-normal" label="ADD PRODUCT" outlined onClick={handleOnAddProduct} />
					{/* <div className="flex justify-content-center h-full">
						<ThreeDots height="50" width="50" radius="5"color="#00baac" ariaLabel="three-dots-loading" visible={isLoading} /> 
					</div> */}
					<Button className="h-2rem p-2" label="RESET PRODUCTS" outlined onClick={handleOnResetProductsList} />
				</div>
				<div className="flex flex-column justify-content-end">
					<div className="flex flex-row justify-content-end mt-4">
						<h5 style={{ color: "#26a69a" }}>Total Price : {sellerPO?.totalItemAmountWithTax ? sellerPO?.totalItemAmountWithTax : 0}</h5>
					</div>
					<div className="m-0">
						<p className="font-semibold text-xs mb-1 mt-1">Seller Bank Accounts<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
						{
							sellerData.companyId && (
								sellerBankAccounts.length === 0 ?
									<p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700 text-red-500'>
										Bank Accounts are not found.
										<a style={{ color: '#00baaa' }} target="_blank" href={`/company/bank_details/${sellerData.companyId}`}> Click here </a>
										to add bank account.
									</p>
									:
									<div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
										<DropDownField name="prefBankAccountId" value={prefBankAccountId} options={sellerBankAccounts} optionLabel={eachBankAccount => `${eachBankAccount.bankName} - ${eachBankAccount.accNo}`} optionValue="bankAccId" onChange={(e) => handleOnChangeBankAccount(e)} />
									</div>
							)
						}
					</div>
					<p className="font-semibold text-xs m-0 mr-3">Logistics Charge</p>
					<div className="flex flex-row logistics-details">
						<div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
							<TextInputField name="logisticsBeforeTax" labelText='Logistics Before Tax' value={sellerPO?.logisticsBeforeTax} onChange={e => handleChange(e)} />
						</div>
						{
							isHSNEntryAllowed ?
							<div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
								<TextInputField name="logisticsHSNCode" labelText='Logistics HSN' value={sellerPO?.logisticsHSNCode} onChange={e => handleChange(e)} />
							</div>
							:
							null
						}
						{/* <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
								<DropDownField name="logisticsTDS"  labelText='Logistics TDS' options={updatedTDSOptions} optionLabel="displayTDSSection" optionValue="tdsSectionId" value={sellerPO?.tdsSectionId} onChange={e => handleChange(e)}/>
							</div> */}
						<div className="flex flex-column col-12 mb-2 md:col-3 lg:col-2 lg:mb-0">
							<DropDownField name="logisticsGSTRate" options={gstValues} optionLabel="label" optionValue="value" labelText='Logistics GSTRate' value={sellerPO?.logisticsGSTRate} onChange={e => handleChange(e)} />
						</div>
						{
							pmCompanyConfig.isTDSAutomated ?
							null
							:
							<div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
								<TextInputField name="logisticsTDSValue" labelText='Logistics TDS Value' keyfilter={"pint"} value={sellerPO?.logisticsTDSValue} onChange={e => handleChange(e)} />
							</div>
						}
						{/* {sellerPO.tdsSectionId === 5 &&
							<div className="flex flex-column col-12 mb-2 md:col-1 lg:col-1 lg:mb-0">
								<TextInputField name="logisticsTDSValue" value={sellerPO.logisticsTDSValue} labelText='Other' onChange={handleChange} keyfilter="num" />
							</div>
						} */}
					</div>
					{ sellerData?.companyPaymentTerms &&
						<>
							<p className="font-semibold text-xs m-0 mr-3 mt-2">Payment Terms(view only) <i className="pi pi-info-circle custom-tooltip-payment-terms"></i></p>
							<Tooltip target=".custom-tooltip-payment-terms" position='right'>
								<span>To Update payment terms, please go to companies/company-branch page</span>
							</Tooltip>
							<div className="grid p-2 align-items-center pl-0">
								<div className="flex flex-column col-12  lg:col-2 lg:mb-0">
									<TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter={"pnum"} value={sellerData?.companyPaymentTerms?.payAdvPO} disabled />
								</div>
								<div className="flex flex-column col-12  lg:col-2 lg:mb-0">
									<TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={sellerData?.companyPaymentTerms?.payAdvDelivery} disabled />
								</div>
								<div className="flex flex-column col-12  lg:col-2 lg:mb-0">
									<TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={sellerData?.companyPaymentTerms?.payPDCDelivery} disabled />
								</div>
								<div className="flex flex-column col-12  lg:col-2 lg:mb-0">
									<TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={sellerData?.companyPaymentTerms?.payOnDelivery} disabled />
								</div>
								<div className="flex flex-column col-12  lg:col-1 lg:mb-0">
									<TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={sellerData?.companyPaymentTerms?.payCredit} disabled />
								</div>
								{
									parseFloat(sellerData?.companyPaymentTerms?.payCredit) > 0 || parseFloat(sellerData?.companyPaymentTerms?.payPDCDelivery) > 0 ?
										<div className="flex flex-column col-12 lg:col-2 lg:mb-0">
											<DropDownField name="creditPeriodId" labelText="Credit Period" options={companyCreditPeriods} optionLabel="creditPeriodName" optionValue="creditPeriodId" value={sellerData?.companyPaymentTerms?.creditPeriodId}  disabled/>
										</div> : ""
								}
								<div className="flex flex-column col-12 lg:col-1">
									<p className={`font-bold text-${paymentTermsTotal === 100 ? 'green-600' : 'red-500'}`}>{paymentTermsTotal}</p>
								</div>
							</div>
						</> 
					}
					<p className='font-semibold text-xs mb-2 mt-1'>PM Billing address<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
					<BillingAddressCards billingAddresses={relatedPMBillAddrs} selectedAddressId={pmBillAddrId} handleBillingAddress={handlePMBillAddrr} />
					<p className="font-semibold text-xs mb-2 mt-1">Shipping Addresses<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
					<ShippingAddressCards shippingAddresses={pmShipAddrs} selectedAddressId={selectedShipAddrId} handleShippingAddress={handleShippingAddress} showAddShipAddr={false} />
					<p className="font-semibold text-xs mb-2 mt-1">Seller billing Addresses<span style={{ color: 'red', marginLeft: '1px' }}>*</span></p>
					{
						isBillAddrsLoading ? <p>Seller billing addressess loading...</p> :
						sellerBillAddrs.length === 0 && sellerData?.companyId ?
							<p className='mb-2 mt-0 ml-2 font-semibold billing-address-msg text-700'>Billing addressses are not available. Please contact tech support</p> :
							<BillingAddressCards billingAddresses={sellerBillAddrs} selectedAddressId={selectedBillAddrId} handleBillingAddress={handleSellerBillAddrr} required />
					}

					<div className="flex flex-row justify-content-center">
						<div className="flex flex-column col-12 mb-2 lg:col-9 lg:mb-0">
							<TextAreaField labelText="Remarks" name="remarks" value={remarks} style={{ minHeight: "100px", width: "100%" }} onChange={handleRemarks} />
						</div>
						{ pmCompanyConfig.isTDSAutomated ? 
							<>
								<div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
									<label htmlFor="" style={{ fontSize: "12px", marginBottom: "3px" }}>
										TDS Section Name
										<Tooltip target=".tds-detail" position="top" content="To get this edited, please contact finance team" />
										<i className="pi pi-info-circle tds-detail ml-1"></i>
									</label>
									<TextInputField value={TDSDisplayData.tdsSectionName} disabled />
								</div>
								<div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
									<TextInputField labelText="TDS Value" value={TDSDisplayData.tdsValue} disabled />
								</div>
							</>
							: null 
						}
					</div>
					
					<div className="flex flex-row justify-content-end mt-4">
						<Button className="h-2rem  p-2" label="ADD EXPENSE" onClick={handleOnAddExpense} />
					</div>
				</div>
				<SellerSearch header = "Assign Seller" visible={visibleAssignseller} onHide={()=> setVisibleAssignSeller(false)} handleOnAddSeller={handleOnAddSeller}/>
				<Dialog header="Add Materials"  className="add-rc-product-dialog" visible={isMaterialModalVisible} onHide={() => setIsMaterialModalVisible(false)} style={{ width: '55vw', height: '80vh' }}>
					<MaterialModal setProductsList={setProductsList} products={productsList}/>
				</Dialog> 
			</div>
		</>
	)
}

export default AddExpense;